import { Variant } from '~/@types/product'

import deepEqual from '~/utils/deep-equal'

interface ComparingVariant {
  sku: string
  id: string
  price: string
  priceAmount: string
  availableForSale: boolean
}

/**
 * It takes a Variant and returns a ComparingVariant
 * @param {Variant} variant - Variant - this is the variant object that we're getting from the Shopify
 * API.
 * @returns An object with the properties sku, id, price, priceAmount, and availableForSale.
 */
function getOnlyNeededPropertiesFromVariants(
  variants: Variant[],
): ComparingVariant[] {
  const rewrittenVariants = variants?.map((variant, index) => {
    return {
      sku: variant.sku,
      id: variant.id,
      price: variant.price,
      priceAmount: variant.priceAmount,
      availableForSale: variant.availableForSale,
    }
  })

  return rewrittenVariants
}

/**
 * It compares two variants and returns true if they are equal
 * @param {Variant} x - Variant - The first variant to compare
 * @param {Variant} y - Variant - the variant that we're comparing to
 * @returns A function that takes two arguments, x and y, and returns a boolean.
 */
export default function deepEqualCompareVariants(
  x: Variant[],
  y: Variant[],
): boolean {
  if (x?.length > 0 && y?.length > 0) {
    const firstVariant = getOnlyNeededPropertiesFromVariants(x)
    const secondVariant = getOnlyNeededPropertiesFromVariants(y)

    return deepEqual(firstVariant, secondVariant)
  } else {
    return false
  }
}
